module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/4_6b1a238bdbbe01b60bbd9405e711537a.png";